import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

export const tmdbApi = createApi({
    reducerPath: 'tmdbApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `https://api.themoviedb.org/3`
    }),
    endpoints: () => ({}),
    })